import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <section {...{
      "className": "section-lead"
    }}><p parentName="section">{`Adds `}<a parentName="p" {...{
          "href": "/api/projects/carts#directdiscount"
        }}>{`DirectDiscounts`}</a>{` to the Cart or Order. If not empty, the action replaces all existing DirectDiscounts. If empty, the action removes all existing DirectDiscounts and recalculates all affected prices on the cart or order.
Adding DirectDiscounts is only possible if no `}<a parentName="p" {...{
          "href": "/api/../api/projects/discountCodes#discountcode"
        }}>{`DiscountCode`}</a>{` has been applied to the Cart or Order.`}</p>
      <ul parentName="section">
        <li parentName="ul"><inlineCode parentName="li">{`action`}</inlineCode>{` - String - `}<inlineCode parentName="li">{`"setDirectDiscounts"`}</inlineCode></li>
        <li parentName="ul"><inlineCode parentName="li">{`discounts`}</inlineCode>{` - Array - Required`}<br parentName="li"></br>
          {`The `}<a parentName="li" {...{
            "href": "/api/projects/carts#directdiscountdraft"
          }}>{`DirectDiscountDraft`}</a>{` for an existing `}<a parentName="li" {...{
            "href": "/api/projects/carts#directdiscount"
          }}>{`DirectDiscount`}</a>{`.`}</li>
      </ul>
      <p parentName="section">{`The discounts are applied in the order they are added to this list.`}</p>
    </section>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      